import { Layout } from '@components';

export function SandboxPage() {
  return <Layout>Hello, World!</Layout>;
}
